/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
import {useTeamService} from "../../../services/teamService";

/* Components */
import UCButton from "../../buttons";


/* Styles */
import styles from "./styles.js"
import {colors} from "../../../constants/colors";



const Content = props => {
  const { setShowModal, handleSaveModal, teamId } = props;
  const theme = useTheme();
  const classes = styles({ theme });

  const { deleteTeam } = useTeamService();

  const handleDeleteTeam = async() => {
    const response = await deleteTeam(teamId);
      if (response) {
        setShowModal(false)
        return true;
      }
      return false
  }

  return (
    <div className={classes.modalContent}>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="deleteTeam.cancel"/>}
              />
            </Col>
            <Col className={classes.colRemove} >
              <UCButton
                className={classes.deleteBtn}
                onClick={() => handleDeleteTeam()}
                type="danger"
                text={<FormattedMessage id="deleteTeam.delete"/>}
                spinner={{
                  name: "deleteTeamSpinner",
                  size: 20,
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;
